import "../../css/pages/solutionsV3.scss";
import BasePage from "./base";
import anchorSets from "../modules/anchorSets";
import relatedInsights from "../modules/relatedInsights";
import accordion from "../modules/accordion";
import tabsToggle from "../modules/tabsToggle";
import sectionNavV3 from "../modules/sectionNavV3";

class SolutionsPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        anchorSets.init();
        relatedInsights.init();
        window.addEventListener("load", accordion.init);
        tabsToggle.init();
        sectionNavV3.init();
    }
}

new SolutionsPage();
